import { useState } from "react";

import { FeatureFlag } from "featureFlags/constants";
import { useAllFlags } from "featureFlags/hooks/useAllFlags";
import { Role } from "services/rbac/types";
import { useRbacRoles } from "services/rbac/useRbacRoles";

import { EditRoleModal } from "./EditRoleModal/EditRoleModal";
import { ViewModal } from "./Modals/ViewModal";
import { ViewOnlyContext } from "./useViewOnlyContext";

export const useViewActions = () => {
  const [viewRole, setViewRole] = useState<Role | null>(null);
  const rbacRoles = useRbacRoles();
  const flags = useAllFlags();
  const isRolesWizardEnabled = flags[FeatureFlag.FireboltAppEnableRoleWizard];

  const handleView = (role: Role) => {
    setViewRole(role);
  };

  const closeView = () => {
    setViewRole(null);
  };

  const getViewRoleMarkup = () => {
    if (viewRole) {
      return isRolesWizardEnabled ? (
        <ViewOnlyContext.Provider value={true}>
          <EditRoleModal
            onClose={closeView}
            role={viewRole}
          />
        </ViewOnlyContext.Provider>
      ) : (
        <ViewModal
          viewRole={viewRole}
          onClose={closeView}
          roles={rbacRoles}
        />
      );
    }
    return null;
  };

  const viewRoleMarkup = getViewRoleMarkup();

  return {
    viewRole,
    handleView,
    closeView,
    viewRoleMarkup,
  };
};
